<div class="m-0 h-full bg-surface-page">
  <div class="account-closed text-default">
    <div class="account-closed__title text-default">{{ 'Account closed' | translate }}</div>
    <h3 class="font-bold">{{ 'Thank you for using the software' | translate }}</h3>

    <div class="text-base">
      {{ 'All data will be removed after 30 days!' | translate }}<br />
      <a class="font-semibold" href="/">{{ 'Back to login' | translate }}</a>
    </div>
  </div>
</div>
